import { ChangeEvent, Dispatch, memo, SetStateAction, useEffect, useMemo, useState } from 'react'

import cls from '@UI/crypto_exchange/desktop/components/modals/BorrowRepayModal/BorrowRepayModal.module.scss'

export const RepayInput = ({
  amount,
  setAmount,
  available,
  in_order,
  debt,
}: {
  amount: string
  setAmount: Dispatch<SetStateAction<string>>
  available: number
  in_order: number
  debt: number
}) => {
  const [selectedPercent, setSelectedPercent] = useState(0)
  const countOfItems = 4
  const step = 100 / countOfItems

  const handleInput = (e: ChangeEvent<HTMLInputElement>) => {
    setSelectedPercent(0)
    setAmount(e.target.value)
  }

  const percentBlocks = useMemo(
    () =>
      Array.from({ length: countOfItems }).map((_, idx) => {
        const percent = step * (idx + 1)
        return {
          percent: percent,
          selected: percent <= selectedPercent,
        }
      }),
    [selectedPercent],
  )

  useEffect(() => {
    if (debt && selectedPercent) {
      setAmount(String((debt / 100) * selectedPercent))
    }
  }, [selectedPercent, debt])

  return (
    <div>
      <div className={cls.pairLabel}>
        <div>Amount</div>
        <div className={cls.amountContainer}>
          <div className={cls.amountType}>
            <span className={cls.value}>{Number(available)?.toFixed(6)}</span>
            <span className={cls.type}>Available</span>
          </div>
          /
          <div className={cls.amountType}>
            <span className={cls.value}>{Number(in_order ?? 0)?.toFixed(6)}</span>
            <span className={cls.type}>in order</span>
          </div>
        </div>
      </div>
      <div className={cls.inputContainer}>
        <input className={cls.valueInput} value={amount} onChange={handleInput} />
        <div className={cls.max} onClick={() => setSelectedPercent(100)}>
          MAX
        </div>
      </div>
      <div className={cls.percentContainer}>
        {percentBlocks.map((block, idx) => (
          <PercentButton
            percent={block.percent}
            key={idx}
            setSelectedSquares={setSelectedPercent}
            selected={block.selected}
          />
        ))}
      </div>
    </div>
  )
}

const PercentButton = memo(
  ({
    percent,
    setSelectedSquares,
    selected,
  }: {
    percent: number
    setSelectedSquares: Dispatch<SetStateAction<number>>
    selected: boolean
  }) => {
    return (
      <div className={cls.percentButton} onClick={() => setSelectedSquares(percent)}>
        <div className={`${cls.percentBlock}  ${selected ? cls.active : ''}`} />
        <div>{percent + '%'}</div>
      </div>
    )
  },
)
